// Quantity input rules shared across the order/quotation screens.
//
// Only products sold by the kilogram may have decimal quantities (up to 2
// decimal places). Every other packaging is integer-only.
//
// KG detection accepts either signal, across the different field names the
// product objects use in each screen:
//   - embalagem code prefix (format "KG 2")  -> embalagem / pro_embalagem
//   - unit-of-purchase text ("Kilograma")    -> pro_unidade_compra / packing /
//                                               unidade_compra

export function isKgProduct(product) {
    if (!product) return false;
    let emb = String(product.embalagem || product.pro_embalagem || "")
        .trim()
        .split(" ")[0]
        .toUpperCase();
    let unit = String(
        product.pro_unidade_compra || product.packing || product.unidade_compra || ""
    )
        .trim()
        .toUpperCase();
    return (
        emb === "KG" ||
        unit === "KG" ||
        unit.startsWith("KILO") ||
        unit.startsWith("QUILO")
    );
}

export function normalizeAmount(value, product) {
    let n = parseFloat(String(value).replace(",", "."));
    if (isNaN(n)) return 0;
    return isKgProduct(product)
        ? Math.round(n * 100) / 100 // KG: allow up to 2 decimal places
        : Math.trunc(n); // non-KG: integer only
}
